import { render, staticRenderFns } from "./training_record.vue?vue&type=template&id=3aedd337&scoped=true&"
import script from "./training_record.vue?vue&type=script&lang=js&"
export * from "./training_record.vue?vue&type=script&lang=js&"
import style0 from "./training_record.vue?vue&type=style&index=0&id=3aedd337&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aedd337",
  null
  
)

export default component.exports